import ActionType from './action-type'
import * as Actions from './actions'
import {Api} from '../../../api/Api'
import {type ThunkAction} from 'redux-thunk'
import {type AppState} from '../../types/app-state'
import {REST} from '../../../api'
import {DEFAULT_USER_DATA, type UserData} from './state'
import {type AnyAction} from 'redux'
import {findUserSubscriptions} from '../saved-filters/action-creators'

const CURRENT_USER_REST_URL = '/api/v1/users/current'

export function fetchCurrentUser(): ThunkAction<void, AppState, Api, AnyAction> {
    return (dispatch) => {
        dispatch(requestCurrentUserAction())

        REST.get(CURRENT_USER_REST_URL)
            .then((response) => {
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                dispatch(receiveCurrentUserAction(response.data))
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
                dispatch(findUserSubscriptions(response.data.user))
            })
            .catch(() => dispatch(receiveCurrentUserAction(DEFAULT_USER_DATA)))
    }
}

function requestCurrentUserAction(): Actions.RequestCurrentUserAction {
    return {
        type: ActionType.REQUEST_CURRENT_USER,
    }
}

function receiveCurrentUserAction(currentUser: UserData): Actions.ReceiveCurrentUserAction {
    return {
        type: ActionType.RECEIVE_CURRENT_USER,
        payload: currentUser,
    }
}
